import {connect} from 'react-redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import withStateHandlers from 'recompose/withStateHandlers';
import mapProps from 'recompose/mapProps';
import {readCollection} from '../../../../redux/actions/collections';
import {readFile} from '../../../../redux/actions/files';
import {setTitle} from '../../../../redux/actions/page';
import {getDownloadURL} from '../../../../firebase/storage/download';
import collect from '../../../../services/analytics/collector';
import cancelable from '../../../../../util/cancelable-promise';
import PDFPage from './pdf-page';

function mapStateToProps(state, props) {
	const {
		match: {
			params: {
				fileId
			} = {}
		} = {}
	} = props;
	const file = state.files.resources[fileId];
	const {page: {title}} = state;

	return {
		title,
		file
	};
}

function mapDispatchToProps(dispatch, props) {
	return {
		read() {
			const {
				match: {
					params: {
						collectionId,
						fileId
					} = {}
				} = {}
			} = props;

			dispatch(readCollection(collectionId))
				.then(collections => collections[0])
				.then(collection => dispatch(setTitle(collection.name)));
			return dispatch(readFile(fileId));
		}
	};
}

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	withState('url', 'setURL', ''),
	withState('pageNumbers', 'setPageNumbers', undefined),
	withState('isFullscreen', 'setFullscreen', false),
	withStateHandlers(
		{pageNumber: 0}, {
			setPageNumber: () => pageNumber => {
				const pages = document.getElementsByClassName('ReactPDF__Page');

				for (let i = 0; i < pages.length; i++) {
					const page = pages.item(i);

					if (page.dataset.pageNumber === `${pageNumber}`) {
						page.scrollIntoView(false);
						break;
					}
				}

				return ({pageNumber});
			}
		}
	),
	withStateHandlers(
		{width: 1}, {
			zoomIn: ({width}) => () => ({width: width * 1.05}),
			zoomOut: ({width}) => () => ({width: width * 0.95}),
			setWidth: () => value => ({width: value})
		}
	),
	withHandlers({
		handleDocumentLoad: props => pdf => {
			props.setPageNumbers(pdf.numPages);
			props.setPageNumber(1);
		},
		handleGoBack: props => () => {
			const {location: {pathname}, history} = props;

			history.push(pathname.replace(/\/doc\/[^/]+\/?$/, '/files'));
		}
	}),
	lifecycle({
		componentWillMount() {
			const winWidth = window.screen.width;
			const width = winWidth > 800 ? 768 : winWidth - 32;
			const {
				props: {
					setWidth, setURL, read, history
				}
			} = this;

			setWidth(width);

			read().then(() => {
				const {
					props: {
						file: {
							name, id, collection, media
						}
					}
				} = this;

				if (!name) {
					history.replace('/not-found');
				}

				collect(collection, id);

				const fetchURLTask = cancelable(getDownloadURL(`${collection}/${media}`));

				this.fetchURLTask = fetchURLTask;

				return fetchURLTask.promise;
			}).then(url => setURL({url}))
				.then(() => (this.fetchURLTask = undefined));
		},
		componentWillUnmount() {
			const {fetchURLTask} = this;

			if (fetchURLTask) {
				fetchURLTask.cancel();
			}
		}
	}),
	mapProps(props => {
		const {
			url: {url}, title, classes, handleGoBack,
			handleDocumentLoad, file,
			pageNumber, setPageNumber, pageNumbers,
			setFullscreen, isFullscreen,
			zoomIn, zoomOut, width
		} = props;

		return {
			url,
			file,
			title,
			classes,
			handleGoBack,
			onLoadListener: handleDocumentLoad,
			pageNumber,
			setPageNumber,
			pageNumbers,
			setFullscreen,
			isFullscreen,
			zoomIn,
			zoomOut,
			width
		};
	})
);

export default enhance(PDFPage);



// WEBPACK FOOTER //
// ./src/client/pages/main/file/pdf/index.js